module.exports = __webpack_public_path__ + "img/hero-bg.90dd0cf.jpg";